<template>
  <nav id="leftNav">
    <h3>{{ title }}辅导</h3>
    <div
      v-show="navList.length === 0"
      class="mask">读取中 请稍候...</div>
    <dl
      v-for="(topnav, topindex) in navList"
      :key="topindex"
      class="navList">
      <dt v-if="smallLineHeight">{{ topnav.Name }}</dt>
      <dd
        v-for="(secnav, secindex) in topnav.children"
        :key="secindex"
        @mouseenter="handleMouseEnter(topindex, secindex, topnav.children.length)"
        @mouseleave="handleMouseLeave()"
        :class="smallLineHeight?'bjnavs':''"
      >
        <a
          :href="getSecUrl(secnav.Url, secnav.CategoryCode, secnav.PropertyCondition)"
        >{{ secnav.Name }}</a>
        <transition name="fade">
          <div
            v-show="secnav.children.length && secindex + topindex * topnav.children.length === currentIndex"
            class="secNav">
            <div
              v-for="(thirdnav, thirdindex) in secnav.children"
              :key="thirdindex"
              class="aBox">
              <a :href="getThirdUrl(thirdnav.Url, thirdnav.CategoryCode, thirdnav.PropertyCondition)">{{ thirdnav.Name }}</a>
              <i v-show="thirdindex !== secnav.children.length - 1">|</i>
            </div>
          </div>
        </transition>
      </dd>
    </dl>
  </nav>
</template>

<script>
import { mapState } from 'vuex'
import { getNav } from 'js/getSoukeData.js'
export default {
  name: 'Leftnav',
  data () {
    return {
      navList: [],
      currentIndex: -1
    }
  },
  props: ['title', 'categoryCode'],
  computed: {
    getSecUrl () {
      return function (Url, CategoryCode, PropertyCondition) {
        if (Url) {
          return Url
        } else {
          return `http://souke.xdf.cn/Category/${this.soukecityId}-${CategoryCode}-${PropertyCondition}-0.html?v=5`
        }
      }
    },
    getThirdUrl () {
      return function (Url, CategoryCode, PropertyCondition) {
        if (Url) {
          return Url
        } else {
          return `http://souke.xdf.cn/Category/${this.soukecityId}-${CategoryCode}-${PropertyCondition}-0.html?v=5`
        }
      }
    },
    cityId () {
      return this.soukecityId
    },
    smallLineHeight () {
      if (Number(this.cityId) === 1) {
        return true
      } else {
        return false
      }
    },
    ...mapState(['soukecityId', 'cityName'])
  },
  watch: {
    cityId (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getNavData(newVal, this.categoryCode)
      }
      return newVal
    }
  },
  created () {
    this.getNavData(this.cityId, this.categoryCode)
  },
  methods: {
    getNavData (cityId, categoryCode) {
      getNav(cityId).then(res => {
        res.sort(function (a, b) {
          return a.SortIndex - b.SortIndex
        })
        let navList = []
        res.forEach(function (item) {
          if (item.Depth === 1 && item.CategoryCode === categoryCode) {
            navList.push(item)
            if (item.children === undefined) {
              item.children = []
            }
          }
        })
        navList.forEach(function (topnav) {
          res.forEach(function (item) {
            if (item.Depth === 2 && item.ParentCode === topnav.Code) {
              topnav.children.push(item)
              if (item.children === undefined) {
                item.children = []
              }
            }
          })
        })
        navList.forEach(function (topnav) {
          topnav.children.forEach(function (secnav) {
            res.forEach(function (item) {
              if (item.Depth === 3 && item.ParentCode === secnav.Code) {
                if (secnav.children === undefined) {
                  item.children = []
                }
                secnav.children.push(item)
              }
            })
          })
        })
        this.navList = navList
      })
    },
    handleMouseEnter (group, current, groupLen) {
      this.currentIndex = group * groupLen + current
    },
    handleMouseLeave () {
      this.currentIndex = -1
    }
  }
}
</script>

<style scoped lang="stylus">
@import '~styles/varibles.styl'
@keyframes loading
  0%,100%
    background-color: rgba(0, 0, 0, .5)
  25%
    background-color: rgba(0, 0, 0, .3)
#leftNav
  width: 175px
  height: 524px
  position: relative
  float: left
  background: $themeColor
  margin-right: 8px
  h3
    background: $mainNavTitleColor
    color: #fff
    height: 40px
    font-size: 16px
    line-height: 40px
    position: relative
    padding-left: 20px
  .mask
    position: absolute
    top: 40px
    bottom: 0
    left: 0
    right: 0
    text-align: center
    background-color: rgba(0, 0, 0, .3)
    background: url(http://file.xdf.cn/neworiental/images/loading.gif) no-repeat center 40%
    background-size: 10%
    animation: loading 2s infinite
    -webkit-animation: loading 2s infinite
    color: #fff
    line-height: 342px
  .navList
    background: $mainNavBodyColor
    border-left: 1px solid $mainNavBodyColor
    dt
      height: 30px
      line-height: 30px
      padding-left: 20px
      cursor: pointer
      color: #fff
      background: #00aa81
    dd
      height: 32px
      line-height: 32px
      padding: 2px 0 2px 20px
      cursor: pointer
      &:hover
        background: #fff
        padding-left: 27px
        transition: padding-left .3s
      &:hover > a
          color: $themeColor
      & > a
        color: #fff
    .bjnavs
      height: 22px
      line-height: 22px
  .secNav
    position: absolute
    min-height: 462px
    top: 40px
    left: 175px
    background: #fff
    width: 590px
    padding: 10px
    border: 1px solid #e8e8e8
    border-left: none
    z-index: 1
    .aBox
      float: left;
      line-height: 0
      a
        line-height: 20px
        padding: 5px 0
        font-size: 12px
        color: #999
        &:hover
          color: $themeColor
      i
        color: #ccc
        margin: 0 9px
</style>



// WEBPACK FOOTER //
// src/pages/middleschool/components/Leftnav.vue